import "../styles/spinner.css";

const Spinner = () => {
  return (
    <div className="lds-spinner text-gray-400">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Spinner;
